function CircleFullIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={size}
        viewBox='0 0 12 12'
        fill='currentColor'
      >
        <circle cx='6' cy='6' r='6' />
      </svg>
    </span>
  );
}

export default CircleFullIcon;
